// src/hooks/useCreateHappyEnding.js
import { useMutation } from "@tanstack/react-query";

const API_URL =
  import.meta.env.VITE_PAWFRIENDS_API_ENDPOINT_CREATE_HAPPY_ENDING || "";

async function createHappyEnding(data) {
  const res = await fetch(`${API_URL}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    // pokušaj parsirati error iz response body-a
    let errorBody = {};
    try {
      errorBody = await res.json();
    } catch (e) {
      console.error("Failed to parse error response:", e);
    }
    throw new Error(
      `Failed to create happy ending entry: ${errorBody.error || res.statusText}`
    );
  }

  return res.json();
}

export default function useCreateHappyEnding() {
  return useMutation({
    mutationFn: createHappyEnding,
  });
}
